var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTurbine = function SvgTurbine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 120 136"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E6EBED",
    d: "M60 136c23.196 0 42-2.686 42-6s-18.804-6-42-6-42 2.686-42 6 18.804 6 42 6Z",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#CDD7DC",
    d: "m66.837 129.394-5.85-69.82h-3.062l-2.808 69.82s3.452 1.119 11.72 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA6AD",
    d: "M60 52.874s38.668 29.203 44.318 28.159c5.65-1.045-30.033-28.615-30.033-28.615S63.604 50.672 60 52.874Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m95.34 69.34-4.09 4.819a89.767 89.767 0 0 0 8.342 4.948l2.401-3.181c-1.672-1.88-4.02-4.167-6.652-6.585Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA6AD",
    d: "M57.994 53.714s-41.745 24.82-42.895 30.373c-1.15 5.553 37.693-17 37.693-17s5.862-9.18 5.202-13.373Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m28.747 80.057-2.807-5.833a96.398 96.398 0 0 0-7.936 6.225l1.97 3.54c2.416-.931 5.464-2.329 8.773-3.932Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9FA6AD",
    d: "M59.62 52.738s4.56-48.136.933-52.445c-3.626-4.31-8.365 40.401-8.365 40.401s3.841 10.087 7.431 12.044Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#848A90",
    d: "m56.094 13.547 5.828 1.102a88.766 88.766 0 0 0-.24-9.284l-3.691-.482a127.41 127.41 0 0 0-1.897 8.664Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#818181",
    d: "M61.14 46.881h-2.763a3.758 3.758 0 0 0-1.478.24c-.472.178-.905.45-1.275.798-.37.35-.668.77-.878 1.237-.21.467-.329.972-.348 1.486v2.011l-.257 8.875 10.443-.96.295-7.52v-2.012a4.043 4.043 0 0 0-.228-1.541 3.983 3.983 0 0 0-.792-1.333 3.889 3.889 0 0 0-1.234-.919 3.82 3.82 0 0 0-1.485-.362Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M59.024 56.644a2.93 2.93 0 1 0 0-5.86 2.93 2.93 0 0 0 0 5.86Z"
  })));
};
export default SvgTurbine;